<template>

  <div class="mod-production-return">

    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">

      <el-form-item label="退料单号"><el-input v-model="q.returnCode" size="small" clearable style="width:150px" /></el-form-item>

      <el-form-item label="状态">

        <el-select v-model="q.approveStatus" size="small" clearable style="width:120px">

          <el-option label="未审" value="0" /><el-option label="已审" value="2" />

        </el-select>

      </el-form-item>

      <el-form-item>

        <el-button v-if="isAuth('production:productionReturn:list')" type="primary" size="small" @click="search">查询</el-button>

        <el-button v-if="isAuth('production:productionReturn:save')" type="primary" size="small" @click="open()">新增</el-button>

      </el-form-item>

    </el-form>

    <el-table :data="pageList" border v-loading="loading" :header-cell-style="headStyle" @row-dblclick="rowDblclick">

      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />

      <el-table-column prop="code" label="退料单号" min-width="130" header-align="center" align="left">

        <template slot-scope="s">

          <a v-if="isAuth('production:productionReturn:info')" class="code-link" @click="open(s.row, true)">{{ s.row.code }}</a>

          <span v-else>{{ s.row.code }}</span>

        </template>

      </el-table-column>

      <el-table-column prop="productionOrderCode" label="工单号" min-width="120" header-align="center" align="left" />

      <el-table-column prop="bizDate" label="日期" width="110" header-align="center" align="left" />

      <el-table-column prop="approveStatus" label="状态" width="80" header-align="center" align="center">

        <template slot-scope="s"><el-tag :type="s.row.approveStatus === '2' ? 'success' : 'info'" size="small">{{ s.row.approveStatus === '2' ? '已审' : '未审' }}</el-tag></template>

      </el-table-column>

    </el-table>

    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"

      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; pageIndex = 1 }" @current-change="p => { pageIndex = p }" />



    <production-return-add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="load" />

  </div>

</template>



<script>

import request from '../../api/request'

import { fetchPerms } from '../../api/auth'

import ProductionReturnAddOrUpdate from './productionReturn-add-or-update.vue'



export default {

  name: 'ProductionReturn',

  components: { ProductionReturnAddOrUpdate },

  data() {

    return {

      q: { returnCode: '', approveStatus: '' },

      list: [], pageIndex: 1, pageSize: 20, loading: false, permCodes: [], addOrUpdateVisible: false,

      headStyle: { background: '#f5f7fa', color: '#606266', textAlign: 'center' }

    }

  },

  computed: {

    filtered() {

      return this.list.filter(row => !this.q.approveStatus || String(row.approveStatus) === this.q.approveStatus)

    },

    total() { return this.filtered.length },

    pageList() { return this.filtered.slice((this.pageIndex - 1) * this.pageSize, this.pageIndex * this.pageSize) }

  },

  created() { this.loadPerms(); this.load().then(() => this.tryPrefill()) },

  watch: { '$route.query._prefill'() { this.tryPrefill() }, '$route.query.productionOrderId'() { this.tryPrefill() } },

  methods: {

    isAuth(perm) {

      const user = this.$store.state.user || {}

      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []

      if (['TENANT_ADMIN', 'PLATFORM_ADMIN'].indexOf(String(user.roleCode || '')) >= 0 || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true

      return this.permCodes.indexOf(perm) >= 0

    },

    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },

    search() { this.pageIndex = 1; this.load() },

    load() {

      this.loading = true

      return request.get('/production/return/list', { params: { keyword: this.q.returnCode } }).then(res => { this.list = res.data || [] }).catch(() => { this.list = [] }).finally(() => { this.loading = false })

    },

    rowDblclick(row) {

      if (!row || !row.id || !this.isAuth('production:productionReturn:info')) return

      this.open(row, true)

    },

    tryPrefill() {

      const id = this.$route.query.productionOrderId

      if (!id) return

      this.open({ productionOrderId: id, productionOrderCode: this.$route.query.productionOrderCode || '' })

    },

    open(idOrRow, readonly) {

      this.addOrUpdateVisible = true

      this.$nextTick(() => this.$refs.addOrUpdate && this.$refs.addOrUpdate.init(idOrRow || null, !!readonly))

    }

  }

}

</script>



<style scoped>

.list-pagination { margin-top: 12px; text-align: right; }

.toolbar >>> .el-form-item { margin-bottom: 8px; }

.code-link { color: #348adb; cursor: pointer; }

</style>

